import { render } from "./ToiletIcon.vue?vue&type=template&id=4532eab0&scoped=true"
import script from "./ToiletIcon.vue?vue&type=script&lang=js"
export * from "./ToiletIcon.vue?vue&type=script&lang=js"

import "./ToiletIcon.vue?vue&type=style&index=0&id=4532eab0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4532eab0"]])

export default __exports__